import React, {useState, useContext, useEffect, useMemo} from 'react';
import Spinner from '../../../Spinner';
import {useTranslation} from 'react-i18next';
import Datepicker from 'react-tailwindcss-datepicker';
import SelectComponentNotSorted from '../../../Selects/SelectComponentNotSorted';
import SelectComponent from '../../../Selects/SelectFilter';
import {ToastContainer} from 'react-toastify';
import {useHistory, useParams} from 'react-router-dom';
import {Context} from '../../../../Helpers/Auth';
import {toast} from 'react-toastify';
import InputFilter from '../../../Filters/InputFilter';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import moment from 'moment';
import {getEstadosProposta, getHistoricoOrcamento, getRepresentantes, getTiposPropostas} from '../../../../pages/requests';

import {getPropostas} from '../../../../pages/requests';
import {format} from 'date-fns';
import TablePagination from '../../../TablePagination';
import NotFound from '../../../NotFound';
import axios from 'axios';

// import { Container } from './styles';

function Status({
    proposta,
    // filtro status
    filtroDtStatus,
    setFiltroDtStatus,
    filtroUtilizador,
    setFiltroUtilizador,
    filtroAcao,
    setFiltroAcao,
    filtroDestinatarios,
    setFiltroDestinatarios,
    filtroEmail,
    setFiltroEmail,
    statusOcamento,
}) {
    const [loading, setLoading] = useState(false);
    const {t} = useTranslation();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalProdutos, setTotalProdutos] = useState(0);
    const FORMATO_DATA = 'YYYY-MM-DD';
    const FORMATO_DATA_COMPLETO = 'YYYY-MM-DD HH:mm:ss';

    const [historico, setHistorico] = useState([]);
    const propostasFilt = [];

    const ITEMS_PER_PAGE = 15;

    const [isMobile, setIsMobile] = useState(false);

    const {isCard, openCards} = useContext(Context);

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const handleResize = () => {
        setIsMobile(window.innerWidth < 900);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
        getHistoricoOrcamento(indexOfFirstItem, indexOfLastItem - 1, lang, signal, proposta.id, filtroDtStatus.startDate ?? '', filtroUtilizador, filtroAcao, filtroDestinatarios, filtroEmail)
            .then(res => {
                if (res.data.success) {
                    setHistorico(res.data.historico);
                    setTotalProdutos(res.data.registos);
                } else {
                    res.data.errorMessages.map(m => {
                        toast.error(m, {
                            position: 'top-right',
                            autoClose: 6000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: 'light',
                        });
                    });
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log(error);
                }
            })
            .finally(() => {
                //setLoading(false);
            });

        return () => {
            controller.abort();
        };
    }, [currentPage, filtroDtStatus, filtroUtilizador, filtroAcao, filtroDestinatarios, filtroEmail]);

    return (
        <>
            {isMobile || isCard ? (
                <div>
                    {historico?.map((dados, index) => (
                        <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                            <h2 className="mb-0" id="headingOne">
                                <button
                                    className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                    type="button"
                                    data-te-collapse-init
                                    data-te-collapse-collapsed
                                    data-te-target={'#flush-collapseThree' + index}
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    <div className="flex flex-row">{moment(dados.dataHora).format(FORMATO_DATA_COMPLETO)} | {dados.nomeUtilizador} | {dados.acao}</div>
                                    <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                        </svg>
                                    </span>
                                </button>
                            </h2>
                            <div
                                id={'flush-collapseThree' + index}
                                className={openCards ? 'visible' : '!visible hidden'}
                                data-te-collapse-item
                                aria-labelledby="flush-headingThree"
                                data-te-parent="#accordionFlushExample">
                                <div className="px-5 py-4">
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('data')}:</div> {moment(dados.dataHora).format(FORMATO_DATA_COMPLETO)}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('utilizador')}:</div> {dados.nomeUtilizador}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('acao')}: </div> {dados.acao}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('destinatarios')}: </div> {dados.destinatarios}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('email')}: </div> {dados.emailClean}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                        <div>
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalProdutos / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalProdutos}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                        </div>
                        <TablePagination total={totalProdutos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                    </nav>
                </div>
            ) : (
                <div className="relative min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px]">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                            <tr>
                                <th scope="col" className="px-6 py-3">
                                    {t('data')}
                                    <Datepicker
                                        displayFormat={FORMATO_DATA}
                                        useRange={false}
                                        asSingle={true}
                                        value={filtroDtStatus}
                                        onChange={newValue => {
                                            setFiltroDtStatus(newValue);
                                        }}
                                        inputClassName={`rounded-[8px] w-full mt-2 bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('utilizador')}
                                    <InputFilter
                                        value={filtroUtilizador}
                                        onSearch={value => {
                                            setFiltroUtilizador(value);
                                        }}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('acao')}
                                    <InputFilter
                                        value={filtroAcao}
                                        onSearch={value => {
                                            setFiltroAcao(value);
                                        }}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('destinatarios')}
                                    <InputFilter
                                        value={filtroDestinatarios}
                                        onSearch={value => {
                                            setFiltroDestinatarios(value);
                                        }}
                                    />
                                </th>

                                <th scope="col" className="px-6 py-3">
                                    {t('email')}
                                    <div className="flex flex-row">
                                        <InputFilter
                                            value={filtroEmail}
                                            onSearch={value => {
                                                setFiltroEmail(value);
                                            }}
                                        />
                                        {/* {filtroEstado != null || filtroId != null || filtroCliente != '' || filtroTipo != null ? (
                                            <button
                                                onClick={limparFiltros}
                                                type="button"
                                                className="flex items-center border-gray-300 text-gray-600 hover:text-blue-600 bg-gray-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] ml-2 text-xs  text-center dark:bg-gray-600 dark:text-white dark:hover:text-blue-500 dark:focus:ring-blue-800">
                                                <FilterAltOffIcon />
                                            </button>
                                        ) : null} */}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {historico?.map(dados => (
                                <tr className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 ">
                                    <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {moment(dados.dataHora).format(FORMATO_DATA_COMPLETO)}
                                    </th>
                                    <td className="px-6 py-1">{dados.nomeUtilizador}</td>
                                    <td className="px-6 py-1">{dados.acao}</td>
                                    <td className="px-6 py-1">{dados.destinatarios}</td>
                                    <td className="px-6 py-1 text-blue-600 dark:text-blue-500">{dados.emailClean}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/* {semDados && !loading && <NotFound frase={t('semRegistos')} />} */}
                    {loading && (
                        <div className="flex flex-row mt-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )}

                    <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                        <div>
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalProdutos / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalProdutos}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                        </div>
                        <TablePagination total={totalProdutos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                    </nav>
                </div>
            )}
        </>
    );
}

export default Status;
